import React from 'react'

export class Footer extends React.Component {
  render() {
    return (
       <div className='footer'>
        <p className='legal'> Hike Tracker &copy; 2018</p>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Footer.js